import React, {useState} from "react";
import PropTypes from "prop-types";
import {useTheme} from "@mui/styles";
import TopMenu from "../menu/TopMenu";
import {useMediaQuery} from "@mui/system";
import {Box} from "@mui/material";

const HorizontalNavigation = ({content, withIcon}) => {
  const theme = useTheme();
  const renderMiniMenu = useMediaQuery(theme.breakpoints.down("lg"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{backgroundColor: "primary.bgColor"}}>
      <TopMenu
        withIcon={withIcon}
        appBar
        renderMiniMenu={renderMiniMenu}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
      />
      <main style={{flexGrow: 1}}>
        {content}
      </main>
    </Box>
  );
};

HorizontalNavigation.propTypes = {
  content: PropTypes.any,
  withIcon: PropTypes.bool,
  changeOrientation: PropTypes.func
};

export default HorizontalNavigation;
